
import { defineComponent, ref, reactive, onMounted,nextTick } from 'vue'
import type { FormInstance, FormRules, Action } from "element-plus";

//services
import acrdService from "@/core/services/AcrdService";
import { errManager } from "@/core/config/Tools";
import { useI18n } from "vue-i18n/index";

export default defineComponent({
    name: "step-oficial",
    props: {
        idacrd: {
            type: String,
            required: true,
            default: ""
        },
        listFunctions: {
            type: null,
            required: true,
            default: []
        },
        sport: {
            type: null,
            required: false,
            default: []
        }
    },
    setup(props) {
        const { t } = useI18n();
        const loader = ref(false);
        const formRef = ref<FormInstance>();
        const form = reactive(<any>{});
        const rules = reactive<FormRules>({});
        const itemFunction = ref<any>(null);
        //const listFunctions = ref<any>([])

        const getAcrd = async () => {
            loader.value = true
            await acrdService.getAcreditation(props.idacrd, 'show')
                .then((res) => {
                    Object.assign(form, res.data.info)
                    loader.value = false
                }).catch(({ response }) => {
                    loader.value = false
                    errManager(response)
                })
        }

        const getMessageFunction = () => {
            itemFunction.value = props.listFunctions.find( (el:any) => el.idfunction == form.idfunction )
        } 

        onMounted(()=>{

            if(props.idacrd) {
                getAcrd()
            }else {
                //setFunctionFirst()
            }
            //listFunctions.value = props.listFunctions
        })

        return {
            t,
            loader,
            formRef,
            form,
            rules,
            itemFunction,
            //listFunctions,
            getMessageFunction
        }
    },
})
